'use client'

import { memo, useMemo } from 'react'
import Link from 'next/link'

import {
  formatPricePerUnit,
  Pricing,
  ProductSpecialPromotion,
  ProductTypes
} from 'modules/products'
import { addTestId } from 'shared/utils/tests'

import ProductAvailability from './ProductAvailability'

import styles from './CartItemInfo.module.scss'

const CartItemInfo = memo(
  ({
    productPath,
    brand,
    name,
    unitDetails,
    pricePerUnit,
    unitPerPrice,
    hasWeeklyAvailabilityPlan,
    weeklyAvailabilityPlan,
    isAvailableForDeliverySlot,
    originalProduct
  }: {
    productPath: string
    brand?: string
    name: string
    unitDetails: string
    pricePerUnit?: Pricing
    unitPerPrice: string
    hasWeeklyAvailabilityPlan: boolean
    weeklyAvailabilityPlan: { [key: string]: boolean }
    isAvailableForDeliverySlot: boolean
    originalProduct: ProductTypes
  }) => {
    const formattedPath =
      productPath[0] !== '/' ? `/${productPath}` : productPath

    const pricePerUnitFormatted = useMemo(() => {
      return pricePerUnit ? formatPricePerUnit(pricePerUnit, unitPerPrice) : ''
    }, [pricePerUnit, unitPerPrice])

    const productBrand = brand || ''

    return (
      <>
        <Link href={formattedPath} className={styles.productDetails}>
          <div
            className={styles.producerName}
            {...addTestId('cart-product-producer-name')}
          >
            {productBrand}
          </div>
          <div
            className={styles.productName}
            {...addTestId('cart-product-name')}
          >
            {name}
          </div>
          <div
            className={styles.productUnitDetails}
            {...addTestId('cart-product-unit-details')}
          >
            <span {...addTestId('cart-product-unit-details-unit')}>
              {unitDetails}
            </span>{' '}
            <span {...addTestId('cart-product-unit-details-price')}>
              {pricePerUnitFormatted}
            </span>
          </div>
          {hasWeeklyAvailabilityPlan && (
            <div className={styles.webContent}>
              <ProductAvailability
                type='replacements'
                hasWeeklyAvailabilityPlan={hasWeeklyAvailabilityPlan}
                weeklyAvailabilityPlan={weeklyAvailabilityPlan}
                isAvailableForDeliverySlot={isAvailableForDeliverySlot}
              />
            </div>
          )}
          <ProductSpecialPromotion product={originalProduct} />
        </Link>
      </>
    )
  }
)

export default CartItemInfo
